import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Okrug } from './../okrug/okrug';

@Component({
  selector: 'yt-okrug-modal-update',
  templateUrl: './okrug-modal-update.component.html'
})
export class OkrugModalUpdateComponent extends BaseModalUpdateComponent<Okrug> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Okrug>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService,
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
